(function() {
  'use strict';

  function init() {
    const section = document.querySelector('.bigmad-stores');
    if (!section) return;

    const grid = section.querySelector('[data-stores-grid]');
    const cards = Array.from(section.querySelectorAll('[data-store-card]'));
    if (!cards.length) return;

    // Animação de entrada (stagger)
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('is-visible'), i * 100);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      cards.forEach(c => io.observe(c));
    } else {
      cards.forEach(c => c.classList.add('is-visible'));
    }

    const search = section.querySelector('[data-stores-search]');
    const chipsWrap = section.querySelector('[data-stores-chips]');
    const countEl = section.querySelector('[data-stores-count]');
    const emptyEl = section.querySelector('[data-stores-empty]');
    const clearBtn = section.querySelector('[data-stores-clear]');

    // Sem toolbar (1 loja ou filtros desligados) → para por aqui
    if (!search && !chipsWrap) return;

    let activeRegion = 'all';

    // Gera os chips de região a partir das lojas (únicos, ordem de aparição)
    if (chipsWrap) {
      const regions = [];
      cards.forEach(c => {
        const r = (c.dataset.region || '').trim();
        if (r && !regions.includes(r)) regions.push(r);
      });
      regions.forEach(r => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bigmad-stores-chip';
        btn.dataset.region = r;
        btn.textContent = r;
        chipsWrap.appendChild(btn);
      });
    }

    function normalize(str) {
      return (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // remove acentos
    }

    function applyFilters() {
      const term = normalize(search ? search.value.trim() : '');
      let visible = 0;

      cards.forEach(card => {
        const region = (card.dataset.region || '').trim();
        const haystack = normalize(card.dataset.search || '');

        const matchRegion = activeRegion === 'all' || region === activeRegion;
        const matchTerm = !term || haystack.includes(term);

        if (matchRegion && matchTerm) {
          card.classList.remove('is-hidden');
          visible++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      // Contador
      if (countEl) {
        if (visible === 0) {
          countEl.textContent = '';
        } else {
          countEl.textContent = visible === 1
            ? '1 loja encontrada'
            : `${visible} lojas encontradas`;
        }
      }

      // Estado vazio
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (grid) grid.style.display = visible === 0 ? 'none' : '';
    }

    // Busca (com debounce leve)
    if (search) {
      let t;
      search.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(applyFilters, 150);
      });
    }

    // Chips de região
    if (chipsWrap) {
      chipsWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('.bigmad-stores-chip');
        if (!btn) return;
        activeRegion = btn.dataset.region;
        chipsWrap.querySelectorAll('.bigmad-stores-chip').forEach(c => {
          c.classList.toggle('is-active', c === btn);
        });
        applyFilters();
      });
    }

    // Limpar filtros (do empty state)
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        activeRegion = 'all';
        if (search) search.value = '';
        if (chipsWrap) {
          chipsWrap.querySelectorAll('.bigmad-stores-chip').forEach(c => {
            c.classList.toggle('is-active', c.dataset.region === 'all');
          });
        }
        applyFilters();
      });
    }

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
